import { type FC } from 'react'

import { Banner, BannerDescription } from '@wartek-id/banner'

import { useAPIGetCurrentPeriod } from 'api/kinerja/useAPIKinerja'
import { useAPIGetNotificationList } from 'api/kinerja/useAPIKinerjaNotification'
import CardPanduan from 'app/KinerjaBerandaPage/components/CardPanduan'
import { CardUnreadNotification } from 'app/KinerjaBerandaPage/components/CardUnreadNotification'
import CardKinerjaSteps from 'app/KinerjaShared/components/CardKinerjaSteps'
import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'

interface KinerjaBerandaIndexProps {
  showBanner?: boolean
}

const KinerjaBerandaIndex: FC<KinerjaBerandaIndexProps> = ({
  showBanner = false,
}) => {
  const isNotifikasiEnabled =
    process.env.NEXT_PUBLIC_SKP_NOTIFIKASI_ENABLED === 'true'
  const { data: { period } = {} } = useAPIGetCurrentPeriod()

  const { data: dataNotificationList } = useAPIGetNotificationList({
    options: {
      useErrorBoundary: false,
      enabled: isNotifikasiEnabled,
      refetchOnMount: 'always',
    },
  })

  const unreadNotificationCount = dataNotificationList?.meta?.unread ?? 0

  return (
    <>
      <div className="pl-80">
        <KinerjaSidebar sticky activeMenu="beranda" />

        <div className="p-6 flex flex-col gap-6 w-full">
          {showBanner && (
            <Banner
              type="informational"
              title="Selamat datang di tampilan baru Beranda!"
              closable={false}
            >
              <BannerDescription>
                Kunjungi menu di samping untuk akses progres Pengelolaan Kinerja
                Anda.
              </BannerDescription>
            </Banner>
          )}

          {isNotifikasiEnabled && (
            <CardUnreadNotification count={unreadNotificationCount} />
          )}

          <CardPanduan />

          <CardKinerjaSteps period={period} />
        </div>
      </div>
    </>
  )
}
export default KinerjaBerandaIndex
